import { axiosClient } from '@/shared/apis/config';
import { DtoFileExtension } from '@/shared/constants';
import { BaseResponse, ErrorResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { z } from 'zod';

export const patchAccountProfileCompleteFormSchema = z.object({
  extension: z.nativeEnum(DtoFileExtension),
});

export type PatchAccountProfileCompleteForm = z.infer<
  typeof patchAccountProfileCompleteFormSchema
>;

export const patchAccountProfileCompleteApi = async (
  form: PatchAccountProfileCompleteForm,
) => {
  try {
    const response = await axiosClient.patch<BaseResponse>(
      '/v1.0/account/profile/complete',
      form,
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const usePatchAccountProfileCompleteApi = () => {
  return useMutation<
    BaseResponse,
    AxiosError<ErrorResponse>,
    PatchAccountProfileCompleteForm
  >({
    mutationFn: patchAccountProfileCompleteApi,
  });
};
